export default "__VITE_ASSET__Cuo$2mkM__"